import * as React from 'react';
import * as uuid from 'uuid';

function SvgEchIconsUxWindrad(props: React.SVGProps<SVGSVGElement>) {
  const iconUuid = uuid.v4();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" {...props}>
      <g>
        <path d="M43.5 45l-2.7 54h8.6l-2.7-54z" className="st76" />
        <linearGradient
          id={`${iconUuid}_a`}
          x1={29.617}
          x2={60.582}
          y1={70.677}
          y2={70.677}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ec6508" />
          <stop offset={1} stopColor="#f3921c" />
        </linearGradient>
        <path
          fill={`url(#${iconUuid}_a)`}
          d="M50.4 98l-2.7-56.6-2 .1L48.4 98h-6.6l2.7-56.5-2-.1L39.8 98H29.6v2h31v-2z"
        />
        <g>
          <path
            fill="#ffffff"
            d="M30.3 56.5c6.4-3.8 11.3-9 14.6-15.1L10 62.1c6.9 0 13.9-1.8 20.3-5.6z"
            className="st76"
          />
          <path
            fill="#ffffff"
            d="M65.2 46.5c-6.4-3.6-13.5-5.2-20.4-5.1l35.3 19.8c-3.4-5.9-8.4-11.1-14.9-14.7z"
            className="st76"
          />
          <path
            fill="#ffffff"
            d="M44.4.9c-3.4 6-5.4 12.9-5.3 20.3s2.2 14.3 5.8 20.2L44.4.9z"
            className="st76"
          />
          <linearGradient
            id={`${iconUuid}_b`}
            x1={70.927}
            x2={5.574}
            y1={28.356}
            y2={48.779}
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ec6508" />
            <stop offset={1} stopColor="#f3921c" />
          </linearGradient>
          <path
            fill={`url(#${iconUuid}_b)`}
            d="M81 60.7c-3.7-6.3-8.9-11.5-15.3-15.1-6.1-3.4-12.9-5.2-19.9-5.2L45.4.9 43.5.4c-3.6 6.3-5.5 13.5-5.4 20.8.1 7 2 13.8 5.4 19.8l-34 20.2.5 1.9c7.3 0 14.5-2 20.7-5.7 6-3.6 11-8.6 14.4-14.6l34.5 19.4 1.4-1.5zM43.4 5l.4 32.4c-2.4-5-3.7-10.5-3.7-16.1-.1-5.7 1.1-11.2 3.3-16.3zM29.8 55.6C25 58.5 19.6 60.3 14 60.9l27.8-16.5c-3.1 4.5-7.2 8.4-12 11.2zm19.1-13.1c5.5.5 11 2.1 15.8 4.8s9.1 6.5 12.4 11L48.9 42.5z"
          />
        </g>
        <g>
          <circle fill="#ffffff" cx={45.1} cy={41.4} r={4} className="st76" />
          <linearGradient
            id={`${iconUuid}_c`}
            x1={40.1}
            x2={50.1}
            y1={41.413}
            y2={41.413}
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ec6508" />
            <stop offset={1} stopColor="#f3921c" />
          </linearGradient>
          <path
            fill={`url(#${iconUuid}_c)`}
            d="M45.1 46.4c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
          />
        </g>
      </g>
    </svg>
  );
}
export default SvgEchIconsUxWindrad;
